import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialog: {},
  dialogTitle: {
    padding: "11px 20px",
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  dialogTitleTypography: {
    color: theme.palette.error.main,
    fontSize: 20,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  dialogPaper: {
    width: 300
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 20
  },
  countdown: {
    color: theme.palette.common.black,
    fontSize: 40,
    paddingTop: 16
  },
  buttonContinue: {
    color: theme.palette.secondary.dark
  }
}));
